import React, { useState, useContext, useEffect } from 'react';

import { FiEdit2 } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa"
import { TiTick } from "react-icons/ti";
import { GrFormClose } from "react-icons/gr";
import { FaFileDownload, FaFileUpload } from "react-icons/fa";
import { RiShieldUserFill } from "react-icons/ri";
import { MdCreateNewFolder } from "react-icons/md";
import { SiListmonk } from "react-icons/si";
import { IoIosCreate } from "react-icons/io";
import { BsPersonCheck } from "react-icons/bs";
import { GoWorkflow } from "react-icons/go";


import email from '../../../../assets/CandidateProfile/primary-email.svg'
import contact from '../../../../assets/CandidateProfile/primary-contact.svg'
import address from '../../../../assets/CandidateProfile/present-address.svg'
import resume from '../../../../assets/CandidateProfile/primary-resume.svg'
import dollar from "../../../../assets/CandidateProfile/Currency.svg"


import { DContext } from "../../../../context/Datacontext";

import { renderImgUrl } from '../../../../utils/renderImgUrl';
import Overview from './Overview';
import { renderImgSrc } from '../../../../utils/renderImgSrc';
import { useLocation, useNavigate } from 'react-router-dom';
import Experience from './Experience';
import Education from './Education';
import EmployerEntry from './EmployerEntry';
import Skills from './Skills/Skills';
import Highlights from './Highlights/Highlights';
import { apiFetch } from '../../../services/fetchApi';
import { fetchJob } from '../../../services/fetchJob';
import { createProfileAction, fetchProfile, fetchProfileAction } from '../../../services/profileAction';
import JobPagination from '../../Pagination';
import { renderCapitalize } from '../../../../utils/renderCapitalize';
import { fetchCandidateStatusHistories } from '../../../services/Candidate/Profile/fetchCandidateDetails';
import ProfileHistoryStatus from './ProfileHistoryStatus';
import { fetchGetUsers } from '../../../services/fetchGetUser';

export default function Profiles({ candidate }) {

    // Destructure for display
    const { _id, applicantID, candidateID, applicantName, applicantFullName, emailAddress, phoneNumber, profileSummary, currentCTC, resumeAvailable, resumeLink, newResumeStatus, experiences, permanentAddress, presentAddress, experience = {} } = candidate || {};

    const navigate = useNavigate()
    const location = useLocation()
    const { currentUser, BeURL, showAlert } = useContext(DContext);
    const [error, setError] = useState(null);
    const [currentHeader, setCurrentHeader] = useState(location.state?.active || "Overview")
    const [isReadOnly, setIsReadOnly] = useState(true)
    const [userData, setUserData] = useState(null)
    const [endpoint, setEndpoint] = useState(null);
    const [displayFilename, setDisplayFilename] = useState("");
    const [loadingView, setLoadingView] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [summary, setSummary] = useState("")
    const [summaryUpdateStatus, setSummaryUpdateStatus] = useState(false)
    const [summaryLoading, setSummaryLoading] = useState(false)
    const [users, setUsers] = useState('')

    const [processType, setProcessType] = useState('')
    const [allJobs, setAllJobs] = useState(null)
    const [candidateid, setCandidateid] = useState('')
    const [profileAssign, setProfileAssign] = useState(null)
    // const navigate = useNavigate()
    // const location = useLocation()


    useEffect(() => {
        if (profileSummary) {
            setSummary(profileSummary)
        }
    }, [profileSummary])

    useEffect(() => {
        if (processType || candidateid) {
            const fetchprofileAssign = async () => {
                await fetchProfileAction(BeURL, showAlert, setProfileAssign, candidateid)
            }
            fetchprofileAssign()
        }


    }, [processType, candidateid])


    const handleSummaryUpdate = () => {
        if (summaryLoading) return
        if (!summary || summary.length < 10) {
            showAlert("Enter atleast 10 characters for Summary updation")
            return
        }
        setSummaryLoading(true)
        setSummaryUpdateStatus(false)
        apiFetch(`${BeURL}/update-candidate-summary`, {
            credentials: "include",
            method: 'post',
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({ summary })
        })
            .then(res => res.json())
            .then(data => {
                setSummaryLoading(false)
                alert(data.message)
            })
            .catch((err) => {
                setSummaryLoading(false)
                console.log("Error in updating candidate summary:", err)
                alert("Trouble in connecting to the Server! please try again later.")
            })
    }


    useEffect(() => {
        let fetchUser = async () => {
            await fetchGetUsers(BeURL, showAlert, setUsers, candidate?.createdBy || candidate?.user)

        }
        fetchUser()
    }, [candidate?.createdBy])

    const handleSummaryReset = () => {
        setSummaryUpdateStatus(false)
        setSummary(profileSummary)
    }

    const tempApplicantFullName = applicantName ? applicantName : "Candidate"


    // build the base name once:
    const safeName = (tempApplicantFullName).replace(
        /[<>:"/\\|?*.]/g,
        ""
    );
    const expLabel =
        experience.year || experience.month
            ? `[${experience.year || 0}y ${experience.month || 0}m]`
            : "[_Resume]";
    const baseName = `SAN_${safeName}${expLabel}`;

    useEffect(() => {
        if (BeURL && (applicantID || _id)) {
            setEndpoint(`${BeURL}/resume/${_id || applicantID}`);
            if (resumeAvailable && resumeLink) {
                const extMatch = resumeLink.match(/\.(\w+)$/);
                const ext = extMatch ? `.${extMatch[1]}` : ".pdf";
                setDisplayFilename(`${baseName}${ext}`);
            } else {
                setDisplayFilename(`${baseName}.pdf`);
            }
        }
    }, [BeURL, applicantID, _id, resumeAvailable, resumeLink]);

    // View inline if PDF, otherwise download
    const handleView = async () => {
        if (loadingView) return;
        setLoadingView(true);
        try {
            const res = await apiFetch(`${endpoint}?download=0`, {
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Server ${res.status}`);

            const contentType = res.headers.get("content-type") || "";
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);

            if (contentType.includes("pdf")) {
                window.open(blobUrl, "_blank");
            } else {
                // fallback: directly download non-PDFs
                const cd = res.headers.get("content-disposition") || "";
                const fnMatch = cd.match(/filename\*?=?[^']*'?'?([^;"]+)/i);
                const filename = fnMatch
                    ? decodeURIComponent(fnMatch[1])
                    : displayFilename;
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        } catch (err) {
            console.error("View failed:", err);
            alert("Could not load resume for viewing.");
        } finally {
            setLoadingView(false);
        }
    };

    // Always download, using server-sent filename
    const handleDownload = async () => {
        if (loadingDownload) return;
        setLoadingDownload(true);
        try {
            const res = await apiFetch(`${endpoint}?download=1`, {
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Server ${res.status}`);

            const blob = await res.blob();
            const cd = res.headers.get("content-disposition") || "";
            const fnStar = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
            const fnQuoted = cd.match(/filename\s*=\s*"([^"]+)"/i);
            const fnUnquoted = cd.match(/filename\s*=\s*([^;]+)/i);
            let filename;
            if (fnStar) filename = decodeURIComponent(fnStar[1]);
            else if (fnQuoted) filename = fnQuoted[1];
            else if (fnUnquoted) filename = fnUnquoted[1].trim();
            else filename = displayFilename;

            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        } catch (err) {
            console.error("Download failed:", err);
            alert("Could not download resume.");
        } finally {
            setLoadingDownload(false);
        }
    };

    const handleResumeUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("resume", file);

        const res = await apiFetch(`${BeURL}/upload-candidate-resume/${candidate._id}`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const data = await res.json();
        showAlert(data.message);
        if (data.success) {
            window.location.reload();

        }
    };

    const formatNames = values => {
        if (values) {
            return values?.split(/[_-\s]/)?.map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');
        }
        else return " - "
    }
    const renderOwnerCard = (title, data, Icon, date) => {
        if (data || date) {
            return (
                <div className='flex flex-1  gap-3 items-center shadow-[0_0_6px_#bcbfd0] rounded-xl py-2 px-3'>
                    <Icon className='text-primary-400 text-4xl' />
                    <div className='text-[13px] pr-3'>
                        <h4 className='text-slate-600 text-xs'>{title}</h4>
                        {data && <p className='text-black font-medium mt-1'>{data || "N/A"}</p>}
                        {date && <span className='text-xs'>{new Date(date).toLocaleDateString("en-GB")}</span>}
                    </div>
                </div>
            )
        }
        return null
    }

    if (!endpoint) {
        return (
            <div className="p-3 rounded border my-2 bg-slate-100">Loading...</div>
        );
    }

    // Format the address:
    const formatAddress = (address) => {
        let formattedAddress = ''

        if (address && typeof address === 'object' && Object.entries(address).length > 0) {

            if (address.addressLine1) {
                formattedAddress += address.addressLine1

            }
            if (address.addressLine2) {
                formattedAddress += `, ${address.addressLine2}`
            }
            if (address.city) {
                formattedAddress += `, ${address.city}`
            }
            if (address.district) {
                formattedAddress += `, ${address.district}`
            }
            if (address.state) {
                formattedAddress += `, ${address.state}`
            }
            if (address.country) {
                formattedAddress += `, ${address.country}`
            }
            if (address.zipCode) {
                formattedAddress += ` - ${address.zipCode}`
            }

            return formattedAddress
        }
        else return null
    }

    // For Pipeline and submission process:


    const handleCandidateProcess = async (type, id) => {
        setProcessType(type)
        setCandidateid(id)
        await fetchJob(BeURL, setAllJobs, showAlert)


    }


    const handleProfileAction = async (id) => {

        const payload = {
            "jobId": id,
            "candidateId": candidateid,
            "type": processType,

        }
        if (processType === 'submission') {
            payload.status = 'waiting for evalution'
        }

        await createProfileAction(BeURL, showAlert, payload)
    }

    console.log("Candidates", candidate)
    console.log("Users", users)





    return (
        <main className=' '>
            <div className="w-full  min-h-[750px] py-3 px-1 ">

                <div className='md:p-2 my-2'>

                    <div className='flex justify-end'>
                        <button className='flex gap-2 justify-center items-center text-sm py-1 rounded-lg my-2 px-3 hover:bg-slate-50 text-primary-300 cursor-pointer bg-white border-primary-300 border-[0.5px]' onClick={() => navigate(`/update-account/skills?inverse=${true}&candidateId=${candidate._id}`, { state: { from: location.pathname } })}> <FiEdit2 />  Update profile</button>
                    </div>


                    {/* Start of Header */}
                    <div className="p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white">
                        <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-6">

                            <div className="px-4 flex flex-col items-center lg:items-start">
                                <img
                                    className="h-20 md:h-40 rounded-full object-cover aspect-square border"
                                    src={renderImgSrc(candidate?.profilePicLink, candidate?.applicantFullName || candidate?.applicantName)}
                                    alt="profile"
                                />
                                <span className="bg-white text-xs text-primary-300 px-4 py-1 rounded-md font-medium mt-2 md:mt-4">
                                    {applicantID ? `ApplicantID: ${applicantID}` : `CandidateID: ${candidateID}`}
                                </span>
                            </div>

                            <div className="flex-1 text-slate-800 w-full">

                                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                                    <div className='w-full text-center lg:text-left'>
                                        <h3 className="font-semibold lg:text-xl text-black">{applicantName || applicantFullName}</h3>
                                        <p className="text-sm lg:text-md text-[#3D3D3D]">{formatNames(experiences?.[0]?.jobTitle)}</p>
                                        <p className="text-sm lg:text-md text-blue-600 bg-blue-50 rounded font-medium px-3 py-1 w-fit my-1 mx-auto lg:mx-0">{experience?.year ? `${experience.year + 'y '}` : ""}{experience?.month ? `${experience.month + 'm'}` : ""}</p>

                                    </div>


                                    <div className="flex flex-wrap justify-center gap-2 w-full">



                                        <button className={`flex items-center bg-primary-300 font-medium text-sm md:text-md rounded-lg gap-2 text-white px-4 py-2 
              ${loadingDownload ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                                            onClick={handleDownload} aria-disabled={loadingDownload} title="Download Resume">
                                            {loadingDownload ? (
                                                <FaSpinner className="animate-spin text-xl" />
                                            ) : (

                                                <FaFileDownload className='text-xl' />

                                            )}<p>Download Resume</p>
                                        </button>

                                        < button className="flex items-center text-white font-medium text-sm md:text-md rounded-lg gap-2 bg-primary-400 px-4 py-2"
                                            onClick={() => document.getElementById("resumeInput").click()}>
                                            <FaFileUpload className='text-xl' />
                                            <input id="resumeInput" type="file" hidden onChange={handleResumeUpload} />
                                            <p>Upload Resume</p>
                                        </button>

                                        {(currentUser.role !== 'superadmin' && currentUser.role !== 'hlpdesk') && <div className='flex gap-4 ml-2'>
                                            <div className='flex items-center gap-1 cursor-pointer' title='Pipeline' onClick={() => handleCandidateProcess('pipeline', candidate._id)}>
                                                <GoWorkflow className="text-xl " />

                                            </div>

                                            <div className='flex items-center gap-1 cursor-pointer' title='Submission' onClick={() => handleCandidateProcess('submission', candidate._id)}>
                                                <BsPersonCheck className="text-xl " />

                                            </div>
                                        </div>}
                                    </div>
                                </div>

                                <div className='flex justify-start px-1 md:gap-4 gap-1 text-slate-600 my-2 text-xs'>
                                    <p className='font-medium'>Created At  : {new Date(candidate?.createdAt).toLocaleString("en-GB")}</p>
                                    <p className='font-medium'> Updated At : {new Date(candidate?.updatedAt).toLocaleString("en-GB")}</p>
                                    <p className='font-medium'> Views : {candidate?.profileViewCount || 0}</p>
                                    <p className='font-medium'>Downloads : {candidate?.resumeDownloadCount || 0}</p>
                                </div>

                                <div className="flex flex-wrap gap-3 lg:gap-6 items-center my-2 lg:my-3">
                                    {[
                                        { icon: email, label: "Primary Email", value: emailAddress },
                                        { icon: contact, label: "Primary Contact", value: phoneNumber?.number },
                                        { icon: dollar, label: "Current CTC", value: currentCTC.amount },
                                        {
                                            icon: address,
                                            label: "Present Address",
                                            value: formatAddress(presentAddress) || "",
                                        },
                                    ].map((val, idx) => (
                                        <div key={idx} className="flex items-start gap-3  p-3 px-4 rounded-lg bg-[#F8F9FF]">
                                            <img src={val.icon} alt={val.label} />
                                            <div>
                                                <p className="text-sm text-gray-500">{val.label}</p>
                                                <p className="text-sm font-medium">{val.value || "-"}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <div className="flex flex-col lg:flex-row justify-start items-start lg:items-center gap-3 lg:gap-6 mt-3 lg:mt-5">

                                    <div className="w-full lg:w-1/2 bg-gradient-to-tr from-[#F4F4FC] to-[#F9F3FC] rounded-lg py-3 px-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <p className="text-sm text-gray-500">Profile Score</p>
                                            <p className="text-primary-500 text-sm font-medium">{candidate?.score}%</p>
                                        </div>
                                        <div className="w-full bg-[#C8C4CD] rounded-full h-2 relative">
                                            <div
                                                className="bg-[#030213] h-2 rounded-full transition-all duration-500"
                                                style={{ width: `${candidate?.score}%` }}
                                            ></div>
                                        </div>
                                        {currentUser.role === "job-seeker" && <p className='text-xs text-slate-600 mt-1'>Complete your profile to increase visibility to recruiters</p>}
                                    </div>

                                    <div className={`flex items-center gap-3 p-3 px-4 bg-[#F8F9FF] rounded-lg w-full lg:w-auto 
              ${loadingView || loadingDownload ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                                        aria-disabled={displayFilename.endsWith(".pdf") ? !!loadingView : !!loadingDownload}
                                        onClick={displayFilename.endsWith(".pdf") ? handleView : handleDownload}
                                    >
                                        {loadingView || loadingDownload
                                            ? <FaSpinner className="animate-spin text-xl" />
                                            : <img src={resume} className="h-8 w-8" alt="resume" />
                                        }
                                        <div>
                                            <p className="text-base font-medium inline-block">Resume{
                                                (candidate.newResumeStatus
                                                    && (<sup className="  text-xs font-semibold bg-white px-1 text-secondary-300 rounded" title={`${candidate.newResumeUploadOn ? (new Date(candidate.newResumeUploadOn).toLocaleDateString("en-GB")) : ""}`}>new</sup>
                                                    ))
                                            }

                                            </p>

                                            <p className="text-sm lg:text-md text-gray-500">{displayFilename}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Header */}

                    <div className='p-2 md:p-4 md:py-6  bg-white my-6 rounded-xl shadow '>
                        <div className='flex justify-between '>
                            <h5 className='font-medium text-primary-400'> Profile Summary</h5>

                            <div>
                                {
                                    summaryUpdateStatus ?
                                        <div className={`flex gap-2 items-center ${summaryLoading && 'opacity-60'}`}>
                                            <GrFormClose className={`text-primary-300 font-medium text-xl ${summaryLoading ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleSummaryReset} />
                                            <TiTick className={`text-primary-300 font-medium text-xl ${summaryLoading ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleSummaryUpdate} />
                                        </div>
                                        : <FiEdit2 className='text-primary-300 font-medium' onClick={() => setSummaryUpdateStatus(true)} />
                                }
                            </div>

                        </div>
                        <textarea value={summary || 'No data available'} onChange={e => setSummary(e.target.value)}
                            className={`text-black ${summaryUpdateStatus ? "bg-gray-50" : "bg-transparent"} leading-normal first-letter:pl-7 p-3 w-full my-2 rounded-lg text-sm lg:text-md`}
                            rows={summary ? 3 : 1} />

                    </div>

                    {/* Start of Tab Header */}
                    <div className='p-2 bg-white my-2 md:my-6 rounded-xl shadow overflow-x-auto'>
                        <div className='flex justify-evenly gap-4 sm:gap-6 items-start font-medium text-slate-800 bg-[#ECECF0] p-1 rounded-lg min-w-fit'>
                            {
                                ['Overview', 'Skills', 'Experience', 'Education', 'Highlights'].map((header, i) => (
                                    <span key={i} className={` cursor-pointer text-sm md:text-md px-3 md:px-6 lg:px-10 py-2 rounded-lg sha ${currentHeader === header ? ' bg-[#ECF1FF] text-primary-300' : ''}`} onClick={() => setCurrentHeader(header)}>{header}</span>
                                ))
                            }
                        </div>
                    </div>

                    {/* End of Tab Header */}

                    <>
                        {currentHeader === "Overview" && <Overview currentUser={currentUser} candidate={candidate} setCurrentHeader={setCurrentHeader} />}
                        {currentHeader === "Skills" && <Skills candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Experience" && <Experience candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Education" && <Education candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Highlights" && <Highlights candidate={candidate} currentUser={currentUser} />}

                        {
                            (candidate.candidateID) &&
                            <>
                                <h3 className='font-semibold my-3 lg:my-6 text-center'>Ownership</h3>
                                <div className='flex justify-center flex-wrap gap-3 lg:gap-6 my-3'>
                                    {renderOwnerCard("Ownership", candidate?.ownership, RiShieldUserFill)}
                                    {renderOwnerCard("Created by", users?.fullName, SiListmonk)}
                                    {renderOwnerCard("Created At", '', MdCreateNewFolder, candidate?.createdAt)}
                                    {renderOwnerCard("Updated At", '', IoIosCreate, candidate?.updatedAt)}
                                </div>
                            </>
                        }

                        {
                            _id &&
                            <ProfileHistoryStatus candidateId={_id} BeURL={BeURL} showAlert={showAlert} />
                        }

                        <EmployerEntry candidate={candidate || {}} />



                    </>



                </div>
            </div>


            {allJobs && <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center  ">
                <div className="bg-white p-6 rounded-lg w-full space-y-2 max-w-4xl m-2  overflow-y-auto">
                    <h3 className="text-xl text-center  font-semibold text-primary-400">{processType === 'pipeline' ? 'Adding Candidate to Pipeline' : 'Adding Candidate to Submission'}</h3>
                    {
                        allJobs && (
                            <div className="md:flex md:justify-center max-h-96">
                                <div className="overflow-x-auto bg-white rounded-xl   shadow-md  md:w-[1070px]">
                                    <table className="w-full  text-left border-collapse">
                                        <thead className="bg-primary-400 text-white sticky top-0 z-30">
                                            <tr>
                                                <th className="p-3 w-[50px] text-sm">S.No</th>

                                                <th className="p-3 text-sm">Job Code</th>
                                                <th className="p-3 text-sm">Job Title</th>
                                                <th className="p-3 text-sm ">Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allJobs.length > 0 ? (
                                                allJobs.map((job, idx) => {
                                                    // check if this job exists in profileAssign
                                                    const isAssigned = profileAssign?.some((p) => p.job.id === job._id);

                                                    return (
                                                        <tr
                                                            key={job._id}
                                                            className={` transition border-[0.5px] border-slate-100 ${isAssigned ? 'opacity-35' : 'hover:bg-blue-50'
                                                                }`}
                                                        >
                                                            <td className="p-2 text-center">{idx + 1}</td>

                                                            <td className="p-2">
                                                                <p className="text-primary-500 cursor-pointer font-medium">
                                                                    {job.jobId}
                                                                </p>
                                                            </td>

                                                            <td className="p-2">{renderCapitalize(job.title)}</td>

                                                            <td className="p-2">
                                                                <button
                                                                    disabled={isAssigned}
                                                                    className={`border  font-medium rounded-lg px-5 py-1 transition shadow-lg ${isAssigned
                                                                        ? 'cursor-not-allowed bg-gray-200 text-gray-400 '
                                                                        : 'cursor-pointer text-primary-400 hover:bg-primary-200 hover:text-white  '
                                                                        }`}
                                                                    onClick={() => handleProfileAction(job._id)}
                                                                >
                                                                    {processType === 'submission' ? 'Submit' : 'Add'}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td className="p-3 text-center text-gray-500" colSpan="7">
                                                        No jobs found.
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }
                    <div>
                        <JobPagination setAllJobs={setAllJobs} mode={'job'} />
                    </div>
                    <div className='flex justify-end'>
                        <button
                            onClick={() => setAllJobs(null)}
                            className="mt-4 px-4 py-2 bg-primary-400 text-white rounded "
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>}
        </main >
    );
}